export default __webpack_public_path__ + "static/media/arrow-up.0dbff1d6.svg";